import {Component} from '@angular/core';

@Component({
  selector: 'terms-of-service',
  templateUrl: './terms-of-service.html',
})
export class TermsOfServiceCmp {
}
